// extracted by mini-css-extract-plugin
export default {"modalOverlay":"oD-z","modalContent":"pD-z","header":"qD-z","close":"rD-z"};